module.exports = __webpack_public_path__ + "img/fe10ff5.png";